import {FileUpload} from '@mui/icons-material';
import {Typography, useTheme} from '@mui/material';
import PropTypes from 'prop-types';
import {useCallback, useMemo, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import React from 'react';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '4rem 2rem 5rem 2rem',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#ccc',
    borderStyle: 'dashed',
    backgroundColor: '#fdfdfd',
    color: '#aaa',
    outline: 'none',
    transition: 'all .24s ease-in-out',
    transitionProperty: 'border, color',
    cursor: 'pointer',
};

function FileUploadZone({onDrop, ...props}) {
    const maxFiles = props.maxFiles || 0;
    const theme = useTheme();
    const onDropCallback = useCallback((acceptedFiles, rejectedFiles) => onDrop(acceptedFiles, rejectedFiles), [onDrop]);
    const [isHovered, setIsHovered] = useState(false);
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({onDrop: onDropCallback, accept: Boolean(props.accept) ? props.accept : {}, maxFiles});
    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused || isHovered ? {borderColor: theme.palette.info.light, color: '#666'} : {}),
        ...(isDragAccept ? {borderColor: theme.palette.success.light, color: '#666'} : {}),
        ...(isDragReject ? {borderColor: theme.palette.error.light, color: '#666'} : {})
    }), [
        isHovered,
        isFocused,
        isDragAccept,
        isDragReject,
        theme.palette
    ]);

    const getMessage = () => {
        if (isDragReject) {
            return props.invalidFileTypeMessage || 'Dieser Dateityp ist nicht zugelassen';
        }

        if (isDragActive) {
            return `Datei${maxFiles !== 1 ? 'en' : ''} hier ablegen`;
        }

        return `Datei${maxFiles !== 1 ? 'en' : ''} hier ablegen oder klicken um Datei${maxFiles !== 1 ? 'en' : ''} auszuwählen`;
    };

    return (
        <div {...getRootProps({style})} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <input {...getInputProps()} />
            <FileUpload fontSize={'large'} sx={{marginBottom: 2}}/>
            <Typography align={'center'}>{getMessage()}</Typography>
        </div>
    );
}

FileUploadZone.propTypes = {
    onDrop: PropTypes.func.isRequired,
    maxFiles: PropTypes.number,
    accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    invalidFileTypeMessage: PropTypes.string
}

export default FileUploadZone;
